export default class Card {
  public cardNumber?: string;
  public brand?: string;
  public cvv?: string;
  public expirationDate?: string;
  public name?: string;
  public installments?: number;
  public token?: string;
  public document?: string;
  public identificationType = 'CPF';

  // Mercado Pago
  public issuerId?: string;
  public paymentMethodId?: string;
  public transactionAmount?: number;
  public productDescription?: string;
}
